import { useState } from "react";
import locale from "@bonliva-crm/locale";
import { QualityCheckButton } from "../quality-check-button";
import { QualityCheck, QualityCheckProps } from "../quality-check";
import { CriminalRecordLabels } from "../criminal-record-quality-check/criminal-record-labels";
import { RequestCriminalRecordCheckModal } from "../criminal-record-quality-check/request-criminal-record-check-modal";
import { CriminalRecordType } from "@bonliva-crm/graphql";

export function NationalCriminalRecordQualityCheck(props: QualityCheckProps) {
  const { data, consultantData } = props;

  const [open, setOpen] = useState(false);

  if (props.data.Name !== "Belastningsregister Nationella") {
    throw new Error(
      "NationalCriminalRecordQualityCheck can only be used for Belastningsregister Nationella"
    );
  }

  return (
    <>
      <QualityCheck
        {...props}
        withDefaultStatuses={false}
        renderExtraLabels={() => (
          <CriminalRecordLabels data={data} showComment={props.showComment} />
        )}
        renderExtraAction={() => (
          <QualityCheckButton
            text={locale.Order}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              setOpen(true);
            }}
            disabled={open}
          />
        )}
      />

      <RequestCriminalRecordCheckModal
        open={open}
        consultantId={consultantData._id}
        types={[CriminalRecordType.HVB]}
        qualityCheckName="Belastningsregister Nationella"
        qualityTemplate={data.templateName}
        onClose={() => setOpen(false)}
      />
    </>
  );
}
